// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1IvVE","vLegacy":"SelectSecondary_vLegacy__3qL7i","error":"SelectSecondary_error__3PrwG","disabled":"SelectSecondary_disabled__2teLM"};